document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.before-after');

  sections.forEach(section => {
    const container = section.querySelector('.split-image-wrapper');
    const after = section.querySelector('.split-image-after');
    const cursor = section.querySelector('.before-after__cursor'); 

    if (!container || !after || !cursor) return;
  
    let isDragging = false;

    const setPosition = (x) => {
      const rect = container.getBoundingClientRect();
      let offset = x - rect.left;
      offset = Math.max(0, Math.min(offset, rect.width)); // 限制范围 0 ~ 宽度

      const percent = (offset / rect.width) * 100;

      after.style.transition = 'none';
      cursor.style.transition = 'none';

      after.style.clipPath = `inset(0px 0px 0px ${percent}%)`;
      cursor.style.left = `${percent}%`;
    };

    const startDrag = (e) => {
      isDragging = true;
      setPosition(e.type.includes('touch') ? e.touches[0].clientX : e.clientX);
      document.addEventListener('mousemove', onDrag);
      document.addEventListener('touchmove', onDrag);
      document.addEventListener('mouseup', stopDrag);
      document.addEventListener('touchend', stopDrag);
    };

    const onDrag = (e) => {
      if (!isDragging) return;
      setPosition(e.type.includes('touch') ? e.touches[0].clientX : e.clientX);
    };

    const stopDrag = () => {
      isDragging = false;

      // 拖动结束后恢复平滑动画
      after.style.transition = 'clip-path 0.3s ease';
      cursor.style.transition = 'left 0.3s ease';

      document.removeEventListener('mousemove', onDrag);
      document.removeEventListener('touchmove', onDrag);
      document.removeEventListener('mouseup', stopDrag);
      document.removeEventListener('touchend', stopDrag);
    };

    cursor.addEventListener('mousedown', startDrag);
    cursor.addEventListener('touchstart', startDrag, { passive: true });
  });
});